function urlBase64ToUint8Array(base64String) {
  const padding =
    '='.repeat(
      (4 - (base64String.length % 4)) % 4
    );

  const base64 =
    (
      base64String +
      padding
    )
      .replace(/-/g, '+')
      .replace(/_/g, '/');

  const rawData =
    window.atob(base64);

  return Uint8Array.from(
    [...rawData].map(
      (char) =>
        char.charCodeAt(0)
    )
  );
}

export async function activarNotificacionesPush() {
  if (
    !('serviceWorker' in navigator) ||
    !('PushManager' in window)
  ) {
    throw new Error(
      'Este dispositivo no soporta notificaciones push'
    );
  }

  const permiso =
    await Notification.requestPermission();

  if (permiso !== 'granted') {
    throw new Error(
      'Permiso de notificaciones no concedido'
    );
  }

  const registration =
    await navigator.serviceWorker.ready;

  const existingSubscription =
    await registration.pushManager.getSubscription();

  let subscription =
    existingSubscription;

  if (!subscription) {
    const publicKey =
      process.env
        .REACT_APP_VAPID_PUBLIC_KEY;

    if (!publicKey) {
      throw new Error(
        'Falta la clave pública VAPID'
      );
    }

    subscription =
      await registration.pushManager.subscribe({
        userVisibleOnly: true,

        applicationServerKey:
          urlBase64ToUint8Array(
            publicKey
          )
      });
  }

  const token =
    localStorage.getItem('token');

  if (!token) {
    throw new Error(
      'Usuario no autenticado'
    );
  }

  const response =
    await fetch(
      '/api/push/subscribe',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',

          Authorization:
            `Bearer ${token}`
        },

        body:
          JSON.stringify(
            subscription
          )
      }
    );

  const data =
    await response.json();

  if (!response.ok) {
    throw new Error(
      data.message ||
      'Error registrando notificaciones'
    );
  }

  return {
    success: true,
    subscription,
    data
  };
}

export async function desvincularNotificacionesPush() {
  if (
    !('serviceWorker' in navigator) ||
    !('PushManager' in window)
  ) {
    return {
      success: true,
      skipped: true
    };
  }

  const token =
    localStorage.getItem('token');

  if (!token) {
    return {
      success: true,
      skipped: true
    };
  }

  const registration =
    await navigator.serviceWorker.ready;

  const subscription =
    await registration.pushManager.getSubscription();

  if (!subscription) {
    return {
      success: true,
      skipped: true
    };
  }

  const response =
    await fetch(
      '/api/push/unsubscribe',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',

          Authorization:
            `Bearer ${token}`
        },

        body:
          JSON.stringify({
            endpoint:
              subscription.endpoint
          })
      }
    );

  const data =
    await response.json();

  if (!response.ok) {
    throw new Error(
      data.message ||
      'Error desvinculando notificaciones'
    );
  }

  return {
    success: true,
    data
  };
}